import React, {useState, useCallback, useEffect} from "react";

import Input from '../Input'
import {Container, Span} from './styles';

export default function InsertName({item, value, onChange, isEditable}){
  const [isSurpassLengthLimit, setIsSurpassLengthLimit] = useState(false)

  useEffect(() => {
    if(isSurpassLengthLimit){
      setTimeout(() => setIsSurpassLengthLimit(false), 5000)
    }
  }, [isSurpassLengthLimit])

  const handleState = useCallback((event) => {
    onChange(item.value, event.target.value)
    if(item.limit < event.target.value.length) setIsSurpassLengthLimit(true)
  }, [setIsSurpassLengthLimit, onChange, item])

  return(
    <Container isWarning={isSurpassLengthLimit}>
      <div>
        <label>{item.label}</label>
        <div>
          <Input
            maxlength={item.limit + 1}
            onChange={handleState}
            value={value}
            formatter={item.type}
            disabled={isEditable? item.disabled : true}
            type={item.keyboard}
          />
          <Span active={isSurpassLengthLimit}>Limite de {item.limitPrint} caracteres atingido.</Span>
        </div>

      </div>
    </Container>
  )
}
